import { render } from "./InputKokykId.vue?vue&type=template&id=0998c05c"
import script from "./InputKokykId.vue?vue&type=script&lang=js"
export * from "./InputKokykId.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__